<script>
export default {
  name: 'NonDynamicTransportTripConsumablesRow',
  props: {
    index: {
      type: Number,
      required: true,
    },
    tripConsumable: {
      type: Object,
      required: true,
    },
    tripConsumableTypes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showCommentModal: false,
      isFree: false,
    };
  },
  created() {
    if (this.tripConsumable.id) {
      if (!this.tripConsumable.price) {
        this.isFree = true;
      }
    }
  },
  methods: {
    update(attribute, value) {
      this.$emit('update', { index: this.index, attribute, value });
    },
    updateTripConsumableTypeId(event) {
      this.update('transportConsumableTypeId', event.id);
    },
    updateTripConsumableComment(event) {
      return event.length ? this.update('comment', event) : this.update('comment', null);
    },
    updateTripConsumablePrice(event) {
      return event.length ? this.update('price', +event) : this.update('price', null);
    },
    updateTripConsumableOptional(event) {
      this.update('optional', event);
    },
    setPriceFree(event) {
      if (event) {
        this.update('price', null);
      }
    },
  },
};
</script>

<template>
  <v-layout row>
    <v-flex xs4>
      <v-select
        class="mr-2"
        :items="tripConsumableTypes"
        :value="tripConsumable.transportConsumableTypeId"
        item-text="name"
        item-value="id"
        return-object
        solo
        @change="updateTripConsumableTypeId"
      />
    </v-flex>
    <v-flex xs2>
      <v-checkbox
        class="mt-2"
        :input-value="tripConsumable.optional"
        label="Optional"
        @change="updateTripConsumableOptional"
      />
    </v-flex>
    <v-flex>
      <v-checkbox
        class="mt-2"
        :value="!tripConsumable.price"
        v-model="isFree"
        label="Free"
        @change="setPriceFree"
      />
    </v-flex>
    <v-flex xs2>
      <v-text-field
        class="mr-2"
        :value="tripConsumable.price"
        :disabled="isFree"
        label="Price"
        solo
        @input="updateTripConsumablePrice"
      />
    </v-flex>
    <v-flex xs1>
      <v-dialog
        v-model="showCommentModal"
        max-width="300"
        persistent
      >
        <template v-slot:activator="{ on }">
          <v-btn
            class="mb-4 ml-4 table-icon"
            v-on="on"
            fab
            small
            color="primary"
          >
            <v-icon v-on="on" size="20" dark>info</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('nonDynamicTransport.labels.information') }}</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
              :value="tripConsumable.comment"
              :label="$t('nonDynamicTransport.labels.comment')"
              solo
              @input="updateTripConsumableComment"
            />
          </v-card-text>
          <v-divider class="mr-2 ml-2"/>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              color="success"
              @click="showCommentModal = false"
            >
              {{ $t('buttons.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
    <v-flex xs1>
      <v-icon
        class="mt-2"
        color="green darken-2"
        size="35"
        @click="$emit('add')"
      >
        add_box
      </v-icon>
      <v-icon
        color="red accent-4"
        size="35"
        @click="$emit('remove', index)"
      >
        delete
      </v-icon>
    </v-flex>
  </v-layout>
</template>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportTripConsumablesRow.vue